import { App, defineComponent, getCurrentInstance, h } from 'vue';

export const createWcWrapper = (component: any, app: App): any =>
  defineComponent({
    name: 'VueWcWrapper',
    props: {},
    setup(_, ctx) {
      const instance = getCurrentInstance();

      // Assign app context to this instances context, so that we get
      // access to all plugins & global Vue methods inside components.
      // Reason is that we cannot provide our own app context to Vue's
      // `defineCustomElement` function, it creates its own internal app context.
      if (instance) {
        Object.assign(instance.appContext, app._context);
      }

      return () => h(component, { ...ctx.attrs });
    },
  });
